/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  상점사 채팅 — 화면 간 신호
 * ════════════════════════════════════════════════════════════════════════════════
 *  대화 패널(StoreChatPanel)과 좌측 메뉴의 미확인 배지(StoreLayout)는
 *  트리상 멀리 떨어져 있어 props 로 잇기가 마땅치 않다.
 *  전역 상태를 새로 만들 만한 규모도 아니라 window 이벤트 하나로 연결한다.
 *
 *  - 패널이 메세지를 다시 불러오면(=서버에서 읽음처리가 끝나면) 이 이벤트를 쏜다.
 *  - 레이아웃은 이 신호를 받아 미확인 수를 다시 조회한다.
 *    덕분에 채팅을 보고 있는 동안에는 배지가 올라가지 않는다.
 * ════════════════════════════════════════════════════════════════════════════════
 */
export const STORE_CHAT_READ_EVENT = 'btorage:storeChatRead';
